import styled from "styled-components"
import {Col} from "react-bootstrap"

import Flex from "@irati/ui/src/Flex"
import Icon from "@irati/ui/src/Icon"

export const LeftBannerSection = styled(Col)`
  background-color: ${({theme}) => theme.colors.primary1_50};
  padding: ${({theme}) => theme.spacing.onAndHalf} ${({theme}) => theme.spacing.three};
  border-radius: ${({theme}) => theme.spacing.one};
  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  `}
`

export const RightBannerSection = styled(Col)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-color: ${({theme}) => theme.colors.greys.white};
  padding: ${({theme}) => theme.spacing.onAndHalf} ${({theme}) => theme.spacing.three};
  border-top-right-radius: ${({theme}) => theme.spacing.one};
  border-bottom-right-radius: ${({theme}) => theme.spacing.one};
`

export const Banner = styled.div`
  display: flex;
  position: relative;
  margin-top: ${({theme}) => theme.spacing.three};
  margin-bottom: ${({theme}) => theme.spacing.one};
  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    margin-top: ${theme.spacing.four};
    margin-bottom: 0;
    max-height: 248px;
  `}
`

export const FlexWrapper = styled(Flex)`
  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    align-items: center;
  `}
`

export const BannerImage = styled.img`
  height: 130px;
  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    height: 160px;
  `}
`

export const StyledIcon = styled(Icon)`
  position: relative;
  top: ${({theme}) => theme.spacing.half};
`
